import { adminApi } from "../../lib/axios";

export interface AgencyRewardConfigurationRule {
  id: string;
  reward: string;
  rewardTypes: string[];
  revenueThreshold: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateAgencyRewardRuleInput
  extends Omit<
    AgencyRewardConfigurationRule,
    "id" | "createdAt" | "updatedAt"
  > {}

export interface UpdateAgencyRewardRuleInput
  extends Partial<
    Omit<AgencyRewardConfigurationRule, "id" | "createdAt" | "updatedAt">
  > {}

export const adminAgencyRewardsService = {
  async list(): Promise<AgencyRewardConfigurationRule[]> {
    try {
      const res = await adminApi.get("agency-rewards/config");
      return res.data.data || res.data.items || res.data || [];
    } catch (error: any) {
      console.error("Error fetching agency reward conditions:", error);
      return [];
    }
  },

  async create(
    input: CreateAgencyRewardRuleInput
  ): Promise<AgencyRewardConfigurationRule> {
    const res = await adminApi.post("agency-rewards/config", input);
    return res.data.data || res.data.item || res.data;
  },

  async update(
    id: string,
    input: UpdateAgencyRewardRuleInput
  ): Promise<AgencyRewardConfigurationRule> {
    const res = await adminApi.patch(`agency-rewards/config/${id}`, input);
    return res.data.data || res.data.item || res.data;
  },

  async remove(id: string): Promise<{ success: boolean; message?: string }> {
    const res = await adminApi.delete(`agency-rewards/config/${id}`);
    return { success: true, message: res.data?.message };
  },
};

export default adminAgencyRewardsService;
